<template>
  <div class="home">
    <MobileLinks/>





    
  </div>
</template>

<style lang="scss" scoped>
  .home-schedule {
    width: 500px;
  }
</style>

<script>
// @ is an alias to /src
import MobileLinks from '@/components/MobileLinks.vue'


export default {
  name: 'Home',
  components: {
    MobileLinks
  },
  metaInfo() {
        return { 
            meta: [
                { name: 'description', content:  ''},
                { property: 'og:title', content: "Ziggbee - Magical Talking Ferret"},
                { property: 'og:site_name', content: 'Ziggbee'},
                {property: 'og:type', content: 'website'},    
                {name: 'robots', content: 'index,follow'} 
            ]
        }
    }
}
</script>
